import {Button} from '@/components/ui/button/Button'
import styled, {css} from 'styled-components'

export const StyledSplitViewButton = styled(Button)<{$isActive: boolean}>(
    ({theme: {palette}, $isActive}) => css`
        width: fit-content;
        background-color: ${$isActive ? palette.neutral['100'] : 'transparent'};
    `
)
